import { render } from "./BaseTableStatut.vue?vue&type=template&id=0d48c70a&ts=true"
import script from "./BaseTableStatut.vue?vue&type=script&lang=ts"
export * from "./BaseTableStatut.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__